<script setup lang="ts"></script>

<template>
  <h1 class="d-flex flex-column gap-2">Validation page</h1>
</template>
